export enum OperationStatus {
    NotStarted,
    InProgress,
    Completed,
    Failed,
}